export enum Time {
    MilliSeconds = 1,
    Second = MilliSeconds * 1000,
    Minute = Second * 60,
    Hour = Minute * 60,
    Day = Hour * 24,
}
